// extracted by mini-css-extract-plugin
export var orderSummary = "_rs-0";
export var showMoreLessButton = "_rs-1";